export default __webpack_public_path__ + "static/media/opengivinglogo.7dcedb64.jpg";